import { anchorId } from 'src/@prep/shared/tour';

const a = anchorId;

/**
 * Anchor ids of the "Start work" workflow outside the remediation screen.
 * Templates register them with `[prepTourAnchor]`; the onboarding confirm
 * button is registered from code (`GuidedWorkflowService.confirmOpened`).
 */
export const WORKFLOW_ANCHORS = {
  dashboard: {
    /** The + (Upload file) button of the dashboard. */
    add: a('workflow.dashboard.add'),
    /** The card of the file this workflow uploaded (one card at a time). */
    card: a('workflow.dashboard.card'),
  },
  upload: {
    /** The whole upload block (drop zone + queue). */
    area: a('workflow.upload.area'),
    dropzone: a('workflow.upload.dropzone'),
    uploadButton: a('workflow.upload.uploadButton'),
    /** The three onboarding walkthrough files. */
    samples: a('workflow.upload.samples'),
    /** Confirm button of the onboarding confirmation dialog. */
    confirm: a('workflow.upload.confirm'),
  },
} as const;

/**
 * Anchor ids inside the remediation screen the workbench leg points at. The
 * ids mirror the workspace's `GUIDE_ANCHORS` so the guide definitions port
 * unchanged.
 */
export const WORKBENCH_ANCHORS = {
  top: {
    /** The Checker menu button of the top toolbar. */
    checker: a('workbench.top.checker'),
    /** The Export menu button. */
    export: a('workbench.top.export'),
    /** The "Download Tagged PDF" row of the Export menu, while it is open. */
    exportTagged: a('workbench.top.export.tagged'),
  },
  checkerPane: a('workbench.checkerPane'),
  checker: {
    /** The compliance-standard selector of the checker pane. */
    filter: a('workbench.checker.filter'),
    /** The pass-rate line. */
    passRate: a('workbench.checker.passRate'),
    /** The Download Checker Report row of the Checker menu. */
    report: a('workbench.checker.report'),
    /** Moves with the fix-it guide's cursor over the failing rows. */
    focusedIssue: a('workbench.checker.focusedIssue'),
  },
} as const;
